import React from "react";
import Layout from "./Layout/Layout";
import IMG1 from "../assets/ChakaBace.jpg";
import img2 from "../assets/prabhupada.jpeg";
import GuruMaharaj from "../assets/Guru Maharaj.jpg";
import Program from "./Program";

const About = () => {
  return (
    <Layout>
      <div className="bg-gradient-to-b from-[#fffbf4] to-[#fff6e6] min-h-screen text-stone-900">
        {/* Header Section */}
        <div className="text-center py-16 px-6">
          <span className="text-amber-800 font-semibold text-xs tracking-[0.25em] uppercase mb-3 block">
            Learn More
          </span>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-amber-950 tracking-wider">
            About Our Kendra
          </h1>
          <div className="h-[2px] w-20 bg-amber-500 mx-auto mt-4"></div>
        </div>

        {/* Welcome Section */}
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row justify-center items-center gap-12 px-6 pb-20">
          <div className="lg:w-1/2 flex justify-center">
            <div className="relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500">
              <img
                src={IMG1}
                alt="Temple Photo"
                className="hover:scale-105 transition-transform duration-700 w-full h-auto object-cover rounded-3xl"
              />
            </div>
          </div>

          <div className="lg:w-1/2 bg-white/80 backdrop-blur-sm rounded-3xl p-8 lg:p-10 shadow-md border-l-4 border-amber-500">
            <h2 className="text-2xl sm:text-3xl text-amber-950 font-serif font-bold mb-5 leading-snug">
              Welcome to <span className="text-amber-700">Radha Krishna Gram Vikas Kendra</span>
            </h2>
            <p className="text-stone-700 leading-relaxed font-light text-base sm:text-lg space-y-4">
              <span>
                <strong>Radha Krishna Gram Vikas Kendra</strong> is a non-profit initiative founded by IIT, NIET & MBBS Alumni and Working Professionals.
              </span>
              <br /><br />
              <span>
                Our mission is to nurture culture, values, and Krishna Consciousness among children and their parents, creating a peaceful, supportive society rooted in love, education, and spiritual well-being.
              </span>
            </p>
          </div>
        </div>

        {/* Srila Prabhupada Section */}
        <section className="py-24 px-6 bg-gradient-to-b from-[#fffbf4] to-[#fff6e6] text-stone-900 relative overflow-hidden border-t border-amber-200/50">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(245,158,11,0.03),transparent_80%)] pointer-events-none"></div>
          <div className="max-w-6xl mx-auto relative z-10">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
              <div className="lg:col-span-5 flex justify-center">
                <div className="relative group">
                  <div className="absolute inset-0 bg-amber-900/5 rounded-3xl blur-xl group-hover:bg-amber-900/10 transition-all duration-500"></div>
                  <img
                    src={img2}
                    alt="Srila Prabhupada"
                    className="relative rounded-3xl max-w-full h-auto object-cover shadow-xl border border-amber-900/20 z-10 group-hover:scale-[1.01] transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="lg:col-span-7">
                <span className="text-amber-800 font-semibold text-xs tracking-[0.2em] uppercase mb-2 block">
                  Founder-Acharya of ISKCON
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-amber-950 mb-6 tracking-wide">
                  His Divine Grace A.C. Bhaktivedanta Swami Prabhupada
                </h2>
                <div className="text-stone-700 leading-relaxed font-light space-y-6">
                  <p className="text-base sm:text-lg">
                    His Divine Grace appeared in 1896 in Calcutta, India. He was the beloved disciple of Srila Bhaktisiddhanta Sarasvati Gosvami, who instructed him to spread Vedic knowledge in the English language. 
                  </p>
                  <p className="text-base sm:text-lg">
                    His relentless determination led to the founding of the <span className="text-amber-800 font-medium">International Society for Krishna Consciousness (ISKCON)</span> in 1966 in New York, sparking a global spiritual revolution.
                  </p>
                  <p className="text-base sm:text-lg">
                    Srila Prabhupada’s translations, commentaries, and books remain highly acclaimed scholarly texts, guiding millions to a sublime, conscious way of life.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Guru Maharaj Section */}
        <section className="py-24 px-6 bg-gradient-to-b from-[#fffbf4] to-[#fff6e6] text-stone-900">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
              <div className="lg:col-span-7 order-2 lg:order-1">
                <span className="text-amber-800 font-semibold text-xs tracking-[0.2em] uppercase mb-2 block">
                  Inspirational Guide
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-amber-950 mb-6 tracking-wide">
                  His Holiness Gopal Krishna Goswami Maharaj
                </h2>
                <div className="text-stone-700 leading-relaxed font-light space-y-6">
                  <p className="text-base sm:text-lg">
                    His Holiness was born in New Delhi in 1944. A scholar of global repute, he pursued higher studies at Delhi University, the Sorbonne (Paris), and McGill University (Montreal). 
                  </p>
                  <p className="text-base sm:text-lg">
                    His life was transformed upon meeting Srila Prabhupada in 1968, whose deep compassion inspired him to dedicate his life to kirtan, Vedic culture, and spiritual leadership.
                  </p>
                  <p className="text-base sm:text-lg">
                    Today, Maharaj continues to guide educational, charity, and book distribution missions across the globe, encouraging selfless service and spiritual growth.
                  </p>
                </div>
              </div>
              <div className="lg:col-span-5 flex justify-center order-1 lg:order-2">
                <div className="relative group">
                  <div className="absolute inset-0 bg-amber-900/5 rounded-3xl blur-xl group-hover:bg-amber-900/10 transition-all duration-500"></div>
                  <img
                    src={GuruMaharaj}
                    alt="Gopal Krishna Goswami Maharaj"
                    className="relative rounded-3xl max-w-full h-auto object-cover shadow-2xl border border-amber-900/20 z-10 group-hover:scale-[1.01] transition-transform duration-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Program Section */}
        <div>
          <Program />
        </div>
      </div>
    </Layout>
  );
};

export default About;
